import { QesIcons } from "@app/shared/icons/qesIcons";
import * as React from "react";
import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QESButton } from "@app/shared/qes-standards/Button";

interface InfoBadgeProps {
  /**
   *  Used for the QA automated test handle, and as the element's unique ID
   */
  testId: string;
  /**
   * Content to be displayed inside the badge
   */
  content: JSX.Element | string;
  /**
   * Function that runs when the badge is clicked
   */
  onClick?: () => void;
  /**
   * The icon used to hint at the filter badge's on click action. For example, X for closing (default).
   */
  icon?: QesIcons | null;
  /**
   * Accessible label for the button. Use when the visible content alone doesn't describe the action
   * (e.g. "Remove filter LOB: Medicare Advantage" for a dismiss chip).
   */
  ariaLabel?: string;
  /**
   * The name of an additional CSS class
   */
  className?: string;
  /**
   * The fill color of the badge
   */
  backgroundColor?: string;
  /**
   * The color of the content
   */
  contentColor?: string;
  /**
   * The border color of the badge
   */
  borderColor?: string;
  /**
   * The icon color of the badge
   */
  iconColor?: string;
  /**
   * Side of the icon
   */
  iconSide?: "left" | "right";
  /**
   * Size of the icon
   */
  iconSize?: string;
}

export const InfoBadge: React.FC<InfoBadgeProps> = ({
  content,
  onClick,
  testId,
  icon = QesIcons.X,
  ariaLabel,
  className,
  backgroundColor,
  contentColor,
  borderColor,
  iconColor,
  iconSide = "right",
  iconSize,
}) => {
  return (
    <QESButton
      qesTestId={testId}
      qesType="none"
      aria-label={ariaLabel}
      className={"qes-info-badge" + (!!className ? " " + className : "")}
      onClick={ !!onClick ? onClick : () => {} }
      style={{
        ...(backgroundColor && {backgroundColor: backgroundColor}),
        ...(borderColor && {borderColor: borderColor}),
        ...(contentColor && {color: contentColor}),
        pointerEvents: !!onClick ? "auto" : "none"
      }}
    >
      {iconSide === "right" && content}
      {!!icon &&
        <QesIcon
          iconName={icon}
          width={!!iconSize ? iconSize : "1rem"}
          height={!!iconSize ? iconSize : "1rem"}
          color={iconColor}
          style={{fill: iconColor}}
          isDecorative
        />
      }
      {iconSide === "left" && content}
    </QESButton>
  );
}
